// The secondary line under a workspace name: its city, or an empty string when
// no city is known.
export function workspaceSecondaryLine(workspace: {
  city: string | undefined;
}): string {
  return workspace.city?.trim() ?? "";
}
